import { HeaderNotificationWrapper } from "./HeaderNotification.style";
import { ReactComponent as BellIcon } from "../../assets/images/bell-icon.svg";
import { MuiBox } from "..";

export const HeaderNotification = () => {
  return (
    <HeaderNotificationWrapper>
      <MuiBox className="notificationBg" aria-label="" role={"button"}>
        <BellIcon
          className="notificationIcon"
          aria-label="notification"
          data-testid="notification-icon"
          tabIndex={0}
        />
      </MuiBox>
    </HeaderNotificationWrapper>
  );
};
